<script>
export default {
  directives: {
    margin: require('./directives/margins').margin,
    marginTop: require('./directives/margins').marginTop,
    marginRight: require('./directives/margins').marginRight,
    marginBottom: require('./directives/margins').marginBottom,
    marginLeft: require('./directives/margins').marginLeft,
  },
  components: {
    CpButton: require('./button').default,
    CpGrid: require('./grid').default,
    CpGridItem: require('./grid-item').default,
    CpIcon: require('./icon').default,
    CpTextInput: require('./inputs/text').default,
    CpUnstyledButton: require('./unstyled-button').default,
    VueSimpleSpinner: require('./vue-simple-spinner').default,
  },

  props: {
    query: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localQuery: this.query,
    };
  },

  computed: {},

  methods: {
    clearQuery() {
      this.localQuery = '';
      this.handleSubmit();
    },
    handleSubmit() {
      this.$emit('update:query', this.localQuery);
    },
  },
};
</script>

<template>
  <cp-grid class="search-page__content" v-margin="0.5" v-margin-bottom="1">
    <cp-grid-item :span="$root.isMobile ? 9 : 10">
      <cp-text-input block v-model="localQuery" placeholder="Search">
        <template #prefix>
          <cp-icon name="search" square></cp-icon>
        </template>
        <template #suffix>
          <cp-unstyled-button link @click="clearQuery"> {{ $root.isMobile ? 'x' : 'Clear' }}</cp-unstyled-button>
        </template>
      </cp-text-input>
    </cp-grid-item>

    <cp-grid-item :span="$root.isMobile ? 3 : 2">
      <cp-button @click="handleSubmit" :primary="$root.isMobile" block style="line-height: normal">
        <template v-if="$root.isMobile">
          <cp-icon name="arrow-right" square title="Search"></cp-icon>
        </template>
        <template v-else> Search </template>
      </cp-button>
    </cp-grid-item>
  </cp-grid>
</template>

<style scoped>
.search-page__content {
  width: 100%;
  margin: 30px auto;
}
@media only screen and (max-width: 768px) {
  .search-page__content {
    margin: 15px auto;
  }
}
</style>
